import React, { Component } from "react";
import "./App.css";
import { Config } from "./constant";
import ChatBody from "./chat/ChatBody";
import { send, getMessage } from "./Socket";
import FormBody from "./form/FormBody";
import { observer } from "mobx-react";
import { CommonStore, IsChatRoomActive, IsSessionActive, SetSessionIsActive } from "./Store";
import qs from "qs";
import FormBodyMobile from "./form/FormBodyMobile";

export default observer(
  class App extends Component {
    constructor(props) {
      super(props);
      const queryParams = qs.parse(window.location.search, { ignoreQueryPrefix: true })
      const { is_mobile } = queryParams
      this.state = {
        isSessionActive: false,
        showViewChat: false,
        isMobile: is_mobile === 'true'
      };
    }




    handleChangeSessionActive = () => {
      SetSessionIsActive()
    };

    onClick = flag => {
      this.setState({
        showViewChat: flag
      });
    };

    onChangeSession = () => {
      SetSessionIsActive()
    };

    onClose = () => {
      window.parent.postMessage({ message: "close" }, "*");
      this.setState({
        showViewChat: false
      });
    };

    render() {
      const isSessionActive = CommonStore.isSessionActive
      const body = this.state.isMobile ? <FormBodyMobile onClose={this.onClose} onChangeSession={this.handleChangeSessionActive} displayPicture={Config.displayPicture()} /> :  <FormBody onClose={this.onClose} onChangeSession={this.handleChangeSessionActive} displayPicture={Config.displayPicture()} />
      console.log('Is mobile', this.state.isMobile)
      return (
        <div>
          {isSessionActive ? (
            <ChatBody onClose={this.onClose} />
          ) : (
            body
          )}
        </div>
      );
    }
  }
);
